import { FC, useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import { fetchData, toasterrormsg } from '../../../../reusable'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { Tr } from '../../../../_metronic/i18n/Tr'

const BusinessPending: FC = () => {

  const t = Tr();
  const location = useLocation();
  const navigate = useNavigate()
  const vendorId = (location.state as any)?.vendorId || '';
  const [businessInfostatus, setBusinessInfostatus] = useState("0");
  const [businessRejectReason, setBusinessRejectReason] = useState("");
  // hotel Details api call
  const viewProfileApiCall = async () => {

    var param: any = {
      vendorId: String(vendorId),
    }
    var response: any = await fetchData("public/viewProfile", param)

    if (response.status == "200") {
      var data = response.data[0]
      // setBusinessInfostatus(data.businessInfostatus)
      setBusinessRejectReason(data.businessRejectReason)
      if (data.businessInfostatus == "1") {
        navigate("../login/");
      }
    }
    else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    if (vendorId != "") {
      viewProfileApiCall();
    }
  }, [vendorId]);
  return (
    <>
      <ToastContainer />
      {/* begin::Title */}
      {
        businessInfostatus == '2' && (
          <>
            <h1 className='fw-bolder fs-1qx text-gray-900 mb-4'>{t('Your Request Is Rejected')}</h1>
            <h5 className='fw-bolder text-gray-700 mb-4'>{t('Reject Reason')}</h5>
            {businessRejectReason && (
              <div className='fw-semibold fs-6 text-gray-500 mb-7'>
                {businessRejectReason}
              </div>
            )}
          </>
        )
      }
      {
        businessInfostatus == '0' && (
          <>
            <h1 className='fw-bolder fs-1qx text-gray-900 mb-4'>{t('Thank You for Signing Up!')}</h1>
            <div className='fw-semibold fs-6 text-gray-500 mb-4'>
              {t('Your account has been successfully submitted for review.')}
            </div>
            <div className='fw-semibold fs-6 text-gray-500 mb-4'>
              {t("Our team will review your details shortly, and you'll receive an email notification once your account is approved. In the meantime, feel free to start preparing your listings.")}
            </div>
            <div className='fw-semibold fs-6 text-gray-500 mb-7'>
              {t("We're excited to have you as part of our community.")}
            </div>
          </>
        )
      }
      {/* end::Title */}

      {/* begin::Text */}

      {/* end::Text */}

      {/* begin::Illustration */}
      <div className='mb-11'>
        <img
          src={toAbsoluteUrl('/media/illustrations/sigma-1/5.png')}
          className='mw-100 mh-300px theme-light-show'
          alt=''
        />
        <img
          src={toAbsoluteUrl('/media/illustrations/sigma-1/5.png')}
          className='mw-100 mh-300px theme-dark-show'
          alt=''
        />
      </div>
      {/* end::Illustration */}

      {/* begin::Link */}
      {
        businessInfostatus == '2' && (
          <div className='mb-0 text-center'>
            <Link to='../personaldetails/' state={{ vendorId: vendorId }} className='btn btn-sm btn-primary'>
              {t('Resubmit Details')}
            </Link>
          </div>
        )
      }
      {
        businessInfostatus == '0' && (
          <div className='mb-0 text-center'>
            <Link to='/' className='btn btn-sm btn-primary'>
              {t('Return Login')}
            </Link>
          </div>
        )
      }
      {/* end::Link */}
    </>
  )
}

export { BusinessPending }
